/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Import } from './Import';
import {
    ImportFromJSON,
    ImportFromJSONTyped,
    ImportToJSON,
    ImportToJSONTyped,
} from './Import';
import type { Merge } from './Merge';
import {
    MergeFromJSON,
    MergeFromJSONTyped,
    MergeToJSON,
    MergeToJSONTyped,
} from './Merge';
import type { BackMatter } from './BackMatter';
import {
    BackMatterFromJSON,
    BackMatterFromJSONTyped,
    BackMatterToJSON,
    BackMatterToJSONTyped,
} from './BackMatter';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
    MetadataToJSONTyped,
} from './Metadata';
import type { Modify } from './Modify';
import {
    ModifyFromJSON,
    ModifyFromJSONTyped,
    ModifyToJSON,
    ModifyToJSONTyped,
} from './Modify';
import type { ExcludeControls } from './ExcludeControls';
import {
    ExcludeControlsFromJSON,
    ExcludeControlsFromJSONTyped,
    ExcludeControlsToJSON,
    ExcludeControlsToJSONTyped,
} from './ExcludeControls';
import type { IncludeControls } from './IncludeControls';
import {
    IncludeControlsFromJSON,
    IncludeControlsFromJSONTyped,
    IncludeControlsToJSON,
    IncludeControlsToJSONTyped,
} from './IncludeControls';

/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    uuid?: string;
    /**
     * 
     * @type {Metadata}
     * @memberof Profile
     */
    metadata?: Metadata;
    /**
     * 
     * @type {Array<Import>}
     * @memberof Profile
     */
    imports?: Array<Import>;
    /**
     * 
     * @type {Array<Merge>}
     * @memberof Profile
     */
    merges?: Array<Merge>;
    /**
     * 
     * @type {Array<Modify>}
     * @memberof Profile
     */
    modifies?: Array<Modify>;
    /**
     * 
     * @type {Array<IncludeControls>}
     * @memberof Profile
     */
    includeControls?: Array<IncludeControls>;
    /**
     * 
     * @type {Array<ExcludeControls>}
     * @memberof Profile
     */
    excludeControls?: Array<ExcludeControls>;
    /**
     * 
     * @type {BackMatter}
     * @memberof Profile
     */
    backMatter?: BackMatter;
    /**
     * 
     * @type {Date}
     * @memberof Profile
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Profile
     */
    updated?: Date;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    oscalVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    documentId?: string;
}

/**
 * Check if a given object implements the Profile interface.
 */
export function instanceOfProfile(value: object): value is Profile {
    return true;
}

export function ProfileFromJSON(json: any): Profile {
    return ProfileFromJSONTyped(json, false);
}

export function ProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): Profile {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'metadata': json['metadata'] == null ? undefined : MetadataFromJSON(json['metadata']),
        'imports': json['imports'] == null ? undefined : ((json['imports'] as Array<any>).map(ImportFromJSON)),
        'merges': json['merges'] == null ? undefined : ((json['merges'] as Array<any>).map(MergeFromJSON)),
        'modifies': json['modifies'] == null ? undefined : ((json['modifies'] as Array<any>).map(ModifyFromJSON)),
        'includeControls': json['includeControls'] == null ? undefined : ((json['includeControls'] as Array<any>).map(IncludeControlsFromJSON)),
        'excludeControls': json['excludeControls'] == null ? undefined : ((json['excludeControls'] as Array<any>).map(ExcludeControlsFromJSON)),
        'backMatter': json['backMatter'] == null ? undefined : BackMatterFromJSON(json['backMatter']),
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'version': json['version'] == null ? undefined : json['version'],
        'title': json['title'] == null ? undefined : json['title'],
        'oscalVersion': json['oscalVersion'] == null ? undefined : json['oscalVersion'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
    };
}

export function ProfileToJSON(json: any): Profile {
    return ProfileToJSONTyped(json, false);
}

export function ProfileToJSONTyped(value?: Profile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'metadata': MetadataToJSON(value['metadata']),
        'imports': value['imports'] == null ? undefined : ((value['imports'] as Array<any>).map(ImportToJSON)),
        'merges': value['merges'] == null ? undefined : ((value['merges'] as Array<any>).map(MergeToJSON)),
        'modifies': value['modifies'] == null ? undefined : ((value['modifies'] as Array<any>).map(ModifyToJSON)),
        'includeControls': value['includeControls'] == null ? undefined : ((value['includeControls'] as Array<any>).map(IncludeControlsToJSON)),
        'excludeControls': value['excludeControls'] == null ? undefined : ((value['excludeControls'] as Array<any>).map(ExcludeControlsToJSON)),
        'backMatter': BackMatterToJSON(value['backMatter']),
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'version': value['version'],
        'title': value['title'],
        'oscalVersion': value['oscalVersion'],
        'documentId': value['documentId'],
    };
}

